import React from "react";
import "../ui/ui.scss";

/**
 * EmptyState — Centered placeholder for empty data sections.
 *
 * Props:
 *   icon        — Lucide component reference (e.g. ClipboardCheck) or rendered JSX
 *   title       — Main heading
 *   description — Subtitle text
 *   action      — React node (button/link below text)
 *   className   — Extra class
 */
const EmptyState = ({ icon, title, description, action, className = "" }) => {
  // Accept both component references (e.g. ClipboardCheck) and pre-rendered JSX
  let iconNode = null;
  if (icon) {
    if (React.isValidElement(icon)) {
      iconNode = icon;
    } else {
      const Icon = icon;
      iconNode = <Icon size={36} />;
    }
  }

  return (
    <div className={`ui-empty ${className}`}>
      {iconNode && <div className="ui-empty__icon">{iconNode}</div>}
      {title && <div className="ui-empty__title">{title}</div>}
      {description && <div className="ui-empty__desc">{description}</div>}
      {action && <div className="ui-empty__action">{action}</div>}
    </div>
  );
};

export default EmptyState;
